import React, { useEffect, useState } from "react";
import { Container, Nav, Tab, Image } from "react-bootstrap";
import { doc, collection, onSnapshot, getDoc } from "firebase/firestore";
import { db } from "../../backend/firebaseFunctions";
import {
  getPresenceLogs,
  getUserData,
  getUserEvents,
  getUserGroups,
  getUserStudents,
  managerLogout,
  getStatsReports,
  getCoaches,
  userObjectMigrate,
  getEvaluationTemplates,
  getEventEvaluationReports,
  submitGlobalTechLog,
  updateUserPaymentDetails,
  writeNewGroup,
  updateExistingGroup,
  deleteGroup,
  writeNewEvent,
  updateExistingEvent,
  deleteEvent,
} from "../../backend/firebaseFunctions";
import "./ManagerDashboard.css";
import companyLogo from "../../images/SimplyCoachFullLogo.png";
import { useAuth } from "../../context/AuthContext";
import { usePaymentCheck, InAppPaymentModal } from "./Payment Components";
import { useRemoteConfig } from "../../context/RemoteConfigContext";

import { MdEvent } from "react-icons/md";
import { RiTeamFill } from "react-icons/ri";
import { IoPeopleCircleSharp } from "react-icons/io5";
import { TbReportAnalytics } from "react-icons/tb";
import { IoMdHome } from "react-icons/io";
import { MdOutlineLogin } from "react-icons/md";
import { VscSettings } from "react-icons/vsc";
import { FaFlag, FaBox } from "react-icons/fa";
import { FaUserTie } from "react-icons/fa";
import { FaGlobe } from "react-icons/fa";

import { useNavigate } from "react-router-dom";

import CustomAlert from "./Robuts Components/CustomAlert";
import EventsPane from "./Custom Panes/Events/EventsPane";
import GroupsPane from "./Custom Panes/Groups/GroupsPane";
import StudentsPane from "./Custom Panes/Students/StudentsPane";
import NewStudentsPane from "./Custom Panes/Students/NewStudentsPane";
import ReportsPane from "./Custom Panes/Reports/ReportsPane";
import HomePane from "./Custom Panes/Home/HomePane";
import TrainingPlanPane from "./Custom Panes/TrainingPlan/TrainingPlanPane";
import SuppliersPane from "./Custom Panes/Suppliers/SuppliersPane";
import TrainingCampPane from "./Custom Panes/TrainingCamp/TrainingCampPane";
import SettingsPane from "./Custom Panes/Settings/SettingsPane";
import LogoutModal from "./Robuts Components/LogoutModal";
import CoachesPane from "./Custom Panes/Coaches/CoachesPane";
import ArchiveStudentsPane from "./Custom Panes/Students/ArchiveStudentsPane";
import CommunityPane from "./Custom Panes/Community/CommunityPane";
import CoachAccountBlocked from "../Coach Dashboard Components/CoachAccountBlocked";
import Joyride, { STATUS } from "react-joyride";
import { FaQuestionCircle, FaExclamationTriangle } from "react-icons/fa";

// Navigation Item Configuration
const NAV_ITEMS = [
  { key: "home", label: "בית", icon: IoMdHome, tourId: "nav-home" },
  {
    key: "community",
    label: "קהילה",
    icon: FaGlobe,
    tourId: "nav-community",
    badge: { text: "חדש", style: "new-feature" },
  },
  { key: "events", label: "אירועים", icon: MdEvent, tourId: "nav-events" },
  { key: "groups", label: "קבוצות", icon: RiTeamFill, tourId: "nav-groups" },
  {
    key: "students",
    label: "ספורטאים",
    icon: IoPeopleCircleSharp,
    tourId: "nav-students",
  },
  {
    key: "reports",
    label: "דוחות",
    icon: TbReportAnalytics,
    tourId: "nav-reports",
  },
  {
    key: "training-plan",
    label: "תוכנית אימון",
    icon: FaFlag,
    tourId: "nav-training-plan",
  },
  { key: "suppliers", label: "ספקים", icon: FaBox, tourId: "nav-suppliers" },
  { key: "coaches", label: "מאמנים", icon: FaUserTie, tourId: "nav-coaches" },
  {
    key: "settings",
    label: "הגדרות",
    icon: VscSettings,
    tourId: "nav-settings",
  },
];

// Navigation Component
const DashboardNavigation = ({ currentTab, onTabSelect, onLogout }) => {
  return (
    <div className="dashboard-nav-pane">
      <div className="nav-logo-area">
        <Image src={companyLogo} alt="Company Logo" className="nav-logo" />
      </div>

      <Nav
        variant="pills"
        className="nav-container"
        activeKey={currentTab}
        onSelect={onTabSelect}
      >
        {NAV_ITEMS.map(({ key, label, icon: Icon, tourId, badge }) => (
          <Nav.Item key={key} className="nav-item">
            <Nav.Link eventKey={key} className="nav-link" data-tour={tourId}>
              <Icon className="icon" size={30} />
              {label}
              {badge && (
                <span style={{ textDecoration: "none" }}>
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      background:
                        "linear-gradient(90deg, #FFA726 0%, #FB8C00 100%)",
                      color: "white",
                      borderRadius: "6px",
                      fontWeight: 600,
                      fontSize: "0.85em",
                      padding: "6px",
                      paddingLeft: "16px",
                      paddingRight: "16px",
                      marginRight: "8px",
                      marginLeft: "8px",
                      boxShadow: "0 2px 6px rgba(255,152,0,0.15)",
                      textDecoration: "none",
                    }}
                  >
                    {badge.text}
                  </span>
                </span>
              )}
            </Nav.Link>
          </Nav.Item>
        ))}

        <div className="nav-divider" />

        <Nav.Item className="nav-item">
          <Nav.Link
            eventKey="logout"
            className="logout-nav-link"
            data-tour="nav-logout"
            onClick={onLogout}
          >
            <MdOutlineLogin className="icon" size={30} />
            התנתק מהחשבון
          </Nav.Link>
        </Nav.Item>
      </Nav>
    </div>
  );
};

// Tab Content Component
const DashboardTabContent = ({
  currentTab,
  userData,
  groups,
  students,
  events,
  presenceLogs,
  coaches,
  professionalContent,
  statsReports,
  evaluationTemplates,
  setEvaluationTemplates,
  evaluationReports,
  ownerID,
  currentUser,
  activateAlert,
  setCurrentTab,
  onEventUpdate,
  onEventAdd,
  onEventDelete,
  onGroupUpdate,
  onGroupAdd,
  onGroupDelete,
  onStudentUpdate,
  onStudentAdd,
  onStudentDelete,
  isNavTourRunning,
}) => {
  const tabPanes = {
    home: (
      <HomePane
        userData={userData}
        groups={groups}
        students={students}
        events={events}
        presenceLogs={presenceLogs}
        activateAlert={activateAlert}
        setCurrentTab={setCurrentTab}
        professionalContent={professionalContent}
        statsReports={statsReports}
        isNavTourRunning={isNavTourRunning}
      />
    ),
    events: (
      <EventsPane
        userID={ownerID || currentUser?.uid}
        userData={userData}
        events={events}
        groups={groups}
        students={students}
        evaluationTemplates={evaluationTemplates}
        activateAlert={activateAlert}
        onEventUpdate={onEventUpdate}
        onEventAdd={onEventAdd}
        onEventDelete={onEventDelete}
      />
    ),
    groups: (
      <GroupsPane
        ownerID={ownerID}
        userID={ownerID || currentUser?.uid}
        userData={userData}
        groups={groups}
        students={students}
        activateAlert={activateAlert}
        onGroupUpdate={onGroupUpdate}
        onGroupAdd={onGroupAdd}
        onGroupDelete={onGroupDelete}
        presenceLogs={presenceLogs}
      />
    ),
    students: (
      <StudentsPane
        userData={userData}
        students={students}
        groups={groups}
        getGroupByID={(groupID) =>
          groups?.find((group) => group.id === groupID) || null
        }
        setCurrentTab={setCurrentTab}
        onStudentUpdate={onStudentUpdate}
        onStudentAdd={onStudentAdd}
        onStudentDelete={onStudentDelete}
        setStudents={() => { }} // This will be handled by the parent
        presenceLogs={presenceLogs}
        style={{
          maxHeight: "60vh",
          overflowY: "auto",
          paddingRight: "10px",
        }}
      />
    ),
    new_students: (
      <NewStudentsPane
        userID={ownerID || currentUser?.uid}
        userData={userData}
        students={students}
        setStudents={() => { }} // This will be handled by the parent
        groups={groups}
        onStudentAdd={onStudentAdd}
        activateAlert={activateAlert}
        setCurrentTab={setCurrentTab}
      />
    ),
    reports: (
      <ReportsPane
        groups={groups}
        students={students}
        presenceLogs={presenceLogs}
        evaluationReports={evaluationReports}
        events={events}
        evaluationTemplates={evaluationTemplates}
        activateAlert={activateAlert}
      />
    ),
    "training-plan": (
      <TrainingPlanPane
        userData={userData}
        professionalContent={professionalContent}
        userID={ownerID || currentUser?.uid}
        activateAlert={activateAlert}
      />
    ),
    suppliers: (
      <SuppliersPane userData={userData} activateAlert={activateAlert} />
    ),
    training_camp: (
      <TrainingCampPane
        userData={userData}
        groups={groups}
        students={students}
        activateAlert={activateAlert}
      />
    ),
    community: (
      <CommunityPane
        userData={userData}
        groups={groups}
        students={students}
        activateAlert={activateAlert}
        evaluationTemplates={evaluationTemplates}
        setEvaluationTemplates={setEvaluationTemplates}
      />
    ),
    coaches: (
      <CoachesPane
        userData={userData}
        groups={groups}
        students={students}
        coaches={coaches}
        activateAlert={activateAlert}
        setCoaches={() => { }} // This will be handled by the parent
        setCurrentTab={setCurrentTab}
      />
    ),
    settings: (
      <SettingsPane
        userData={userData}
        activateAlert={activateAlert}
        userID={ownerID || currentUser?.uid}
        groups={groups}
        students={students}
        events={events}
        coaches={coaches}
        setCurrentTab={setCurrentTab}
      />
    ),
    archive_students: (
      <ArchiveStudentsPane
        userID={ownerID || currentUser?.uid}
        userData={userData}
        students={students}
        setStudents={() => { }} // This will be handled by the parent
        groups={groups}
        onStudentAdd={onStudentAdd}
        activateAlert={activateAlert}
        setCurrentTab={setCurrentTab}
      />
    ),
  };

  return (
    <Tab.Content className="dashboard-content" style={{ padding: 0 }}>
      {Object.entries(tabPanes).map(([key, component]) => (
        <Tab.Pane
          key={key}
          eventKey={key}
          className={key === "home" ? "homepane" : "pane"}
        >
          {component}
        </Tab.Pane>
      ))}
    </Tab.Content>
  );
};

// Mobile Warning Modal Component
const MobileWarningModal = ({ show, onDismiss }) => {
  if (!show) return null;

  return (
    <div className="mobile-warning-modal">
      <div className="mobile-warning-content">
        <FaExclamationTriangle className="mobile-warning-icon" />
        <h2 className="mobile-warning-title">שימו לב!</h2>
        <p className="mobile-warning-message">
          האפליקציה עדיין לא מתאימה לשימוש דרך הטלפון הנייד. מומלץ מאוד להתחבר
          למערכת דרך מחשב.
        </p>
        <button className="mobile-warning-button" onClick={onDismiss}>
          הבנתי
        </button>
      </div>
    </div>
  );
};

const Dashboard = () => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  // Core state
  const [userData, setUserData] = useState(null);
  const [currentTab, setCurrentTab] = useState("home");
  const [isLoading, setIsLoading] = useState(true);

  // Modal states
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);

  // Alert state
  const [alert, setAlert] = useState(null);

  // Data states
  const [events, setEvents] = useState([]);
  const [groups, setGroups] = useState([]);
  const [presenceLogs, setPresenceLogs] = useState([]);
  const [students, setStudents] = useState([]);
  const [coaches, setCoaches] = useState([]);
  const [professionalContent, setProfessionalContent] = useState(null);
  const [statsReports, setStatsReports] = useState([]);
  const [ownerID, setOwnerID] = useState(null);
  const [evaluationTemplates, setEvaluationTemplates] = useState([]);
  const [evaluationReports, setEvaluationReports] = useState({});

  // Payment and notification states
  const [hasShownGracePeriodNotification, setHasShownGracePeriodNotification] =
    useState(false);
  const [hasClosedDismissibleModal, setHasClosedDismissibleModal] =
    useState(false);

  // Joyride tour state
  const [runNavTour, setRunNavTour] = useState(false);

  // Mobile warning modal state
  const [showMobileWarning, setShowMobileWarning] = useState(false);

  // Hooks
  const { paymentsWebActive, isLoading: remoteConfigLoading } =
    useRemoteConfig();
  const {
    needsPayment,
    needsNotification,
    isLoading: paymentCheckLoading,
    isSuspended,
    suspensionReason,
    gracePeriodDaysRemaining,
    currentScenario,
    trialDaysRemaining,
    billingFailureDaysRemaining,
  } = usePaymentCheck(userData);

  // Helper functions
  const activateAlert = (type, title, message) => {
    setAlert({ type, title, message });
    setTimeout(() => setAlert(null), 5000);
  };

  // Mobile detection
  const isMobile = () => {
    return window.innerWidth <= 768;
  };

  const handleMobileWarningDismiss = () => {
    setShowMobileWarning(false);
  };

  const handleLogout = async () => {
    try {
      await managerLogout();
      navigate(`/manager/auth`);
    } catch (err) {
      return err;
    }
  };

  // Event handlers for database-only updates
  const handleEventUpdate = async (updatedEvent) => {
    try {
      await updateExistingEvent(ownerID || currentUser?.uid, updatedEvent);
      // Real-time listener will handle state update
    } catch (error) {
      console.error("Error updating event:", error);
      throw error;
    }
  };

  const handleEventAdd = async (newEvent) => {
    try {
      await writeNewEvent(ownerID || currentUser?.uid, newEvent);
      // Real-time listener will handle state update
    } catch (error) {
      console.error("Error adding event:", error);
      throw error;
    }
  };

  const handleEventDelete = async (eventId) => {
    try {
      await deleteEvent(ownerID || currentUser?.uid, eventId);
      // Real-time listener will handle state update
    } catch (error) {
      console.error("Error deleting event:", error);
      throw error;
    }
  };

  const handleGroupUpdate = async (updatedGroup) => {
    try {
      await updateExistingGroup(ownerID || currentUser?.uid, updatedGroup);
      // Real-time listener will handle state update
    } catch (error) {
      console.error("Error updating group:", error);
      throw error;
    }
  };

  const handleGroupAdd = async (newGroup) => {
    try {
      await writeNewGroup(ownerID || currentUser?.uid, newGroup);
      // Real-time listener will handle state update
    } catch (error) {
      console.error("Error adding group:", error);
      throw error;
    }
  };

  const handleGroupDelete = async (groupId) => {
    try {
      await deleteGroup(ownerID || currentUser?.uid, groupId);
      // Real-time listener will handle state update
    } catch (error) {
      console.error("Error deleting group:", error);
      throw error;
    }
  };

  const handleStudentUpdate = (updatedStudent) => {
    setStudents((prev) =>
      prev.map((student) =>
        student.id === updatedStudent.id ? updatedStudent : student
      )
    );
  };

  const handleStudentAdd = (newStudent) => {
    setStudents((prev) => [...prev, newStudent]);
  };

  const handleStudentDelete = (studentId) => {
    setStudents((prev) => prev.filter((student) => student.id !== studentId));
  };


  // Payment handling
  const handlePaymentComplete = async (paymentDetails) => {
    try {
      if (!currentUser?.uid) {
        throw new Error("משתמש לא מזוהה");
      }

      const result = await updateUserPaymentDetails(
        currentUser.uid,
        paymentDetails
      );

      if (result.success) {
        setUserData(result.userData);
        setShowPaymentModal(false);
        activateAlert(
          "success",
          "המנוי הופעל",
          "כעת אפשר להמשיך להשתמש במערכת"
        );
      }
    } catch (error) {
      console.error("Error updating payment details:", error);
      activateAlert(
        "error",
        "שגיאה",
        `שגיאה בעדכון פרטי התשלום: ${error.message}`
      );
    }
  };

  // Determine what to render based on current state
  const shouldShowDashboard = () => {

    if (!paymentsWebActive) return true;
    if (needsPayment && !hasClosedDismissibleModal && currentScenario !== "H")
      return false;
    if (needsNotification && userData?.userType === "coach") return false;
    return true;
  };

  const shouldShowCoachBlocked = () => {
    if (!paymentsWebActive) return false;
    if (userData?.userType !== "coach") return false;
    if (needsNotification) return true;
    if (isSuspended && suspensionReason === "grace_period_expired") return true;
    return false;
  };

  // Effects
  useEffect(() => {
    const shouldShowPaymentModal = () => {
      return (
        paymentsWebActive &&
        needsPayment &&
        !paymentCheckLoading &&
        !showPaymentModal &&
        userData &&
        !hasClosedDismissibleModal &&
        currentScenario !== "H"
      );
    };

    if (shouldShowPaymentModal()) {
      setHasClosedDismissibleModal(false);
      setShowPaymentModal(true);
    }
  }, [
    paymentsWebActive,
    needsPayment,
    paymentCheckLoading,
    showPaymentModal,
    userData,
    hasClosedDismissibleModal,
    currentScenario,
  ]);

  useEffect(() => {
    if (
      (!needsPayment && showPaymentModal && hasClosedDismissibleModal) ||
      currentScenario === "H"
    ) {
      setShowPaymentModal(false);
    }
  }, [
    needsPayment,
    showPaymentModal,
    hasClosedDismissibleModal,
    currentScenario,
  ]);

  useEffect(() => {
    if (currentScenario === "H" && showPaymentModal) {
      setShowPaymentModal(false);
    }
  }, [currentScenario, showPaymentModal]);

  useEffect(() => {
    if (
      paymentsWebActive &&
      needsNotification &&
      !paymentCheckLoading &&
      userData &&
      userData.userType === "coach"
    ) {
      activateAlert(
        "warning",
        "התראה",
        "המנהל שלך צריך להשלים את תהליך התשלום כדי שתוכל להמשיך להשתמש במערכת"
      );
    }
  }, [paymentsWebActive, needsNotification, paymentCheckLoading, userData]);

  useEffect(() => {
    if (!isSuspended || suspensionReason !== "within_grace_period") {
      setHasShownGracePeriodNotification(false);
      return;
    }

    if (
      paymentsWebActive &&
      isSuspended &&
      suspensionReason === "within_grace_period" &&
      !paymentCheckLoading &&
      userData &&
      !hasShownGracePeriodNotification
    ) {
      activateAlert(
        "warning",
        "התראה",
        `החשבון שלך מושעה, אך נשארו לך ${gracePeriodDaysRemaining} ימי שימוש עד סיום המנוי.`
      );
      setHasShownGracePeriodNotification(true);
    }
  }, [
    paymentsWebActive,
    isSuspended,
    suspensionReason,
    paymentCheckLoading,
    userData,
    gracePeriodDaysRemaining,
    hasShownGracePeriodNotification,
  ]);

  // Data fetching effect
  useEffect(() => {
    (async function fetchData() {
      if (!currentUser) return;

      try {
        setIsLoading(true);
        const userId = currentUser.uid;

        await userObjectMigrate(userId);
        const userData = await getUserData(userId);
        setUserData(userData);

        const actorType = userData.userType === "coach" ? "coach" : "manager";
        submitGlobalTechLog({
          action: "web_user_app_open",
          actorId: userId,
          actorType: actorType,
          targetId: "-",
          targetType: "-",
        }).catch((logError) =>
          console.error("Failed to submit global tech log:", logError)
        );

        const targetUserID =
          userData.userType === "coach"
            ? userData.userOrganization.organizationOwnerID
            : userId;

        const [
          studentsData,
          statsReportsData,
          coachesData,
          evaluationTemplatesData,
        ] = await Promise.all([
          getUserStudents(targetUserID),
          getStatsReports(targetUserID),
          getCoaches(targetUserID),
          getEvaluationTemplates(targetUserID),
        ]);

        // Get groups for presence logs (will be updated by real-time listener)
        const groupsData = await getUserGroups(targetUserID);
        const updatedPresenceLogs = await getPresenceLogs(
          targetUserID,
          groupsData.map((group) => group.id)
        );

        // Get events for evaluation reports (will be updated by real-time listener)
        const eventsData = await getUserEvents(targetUserID);
        const evaluationReportsData = {};
        for (const event of eventsData) {
          const reports = await getEventEvaluationReports(
            targetUserID,
            event.id
          );
          evaluationReportsData[event.id] = reports;
        }

        setOwnerID(targetUserID);
        setStatsReports(statsReportsData);
        setPresenceLogs(updatedPresenceLogs);
        setStudents(studentsData);
        setCoaches(coachesData);
        setEvaluationTemplates(evaluationTemplatesData);
        setEvaluationReports(evaluationReportsData);
      } catch (error) {
        activateAlert("error", "Error", "Failed to initialize dashboard data");
      } finally {
        setIsLoading(false);
      }
    })();
  }, [currentUser]);

  // Real-time data listeners
  useEffect(() => {
    if (!currentUser?.uid) return;

    const userUnsubscribe = onSnapshot(
      doc(db, "users", currentUser.uid),
      async (userDocSnapshot) => {
        if (userDocSnapshot.exists()) {
          const rawUserData = userDocSnapshot.data();

          // Apply the same logic as getUserData for coaches
          if (rawUserData.userType === "coach" && rawUserData.userOrganization?.organizationOwnerID) {
            const managerId = rawUserData.userOrganization.organizationOwnerID;
            const coachDocRef = doc(db, "users", managerId, "coaches", currentUser.uid);
            const coachDoc = await getDoc(coachDocRef);

            // Default coach data with full access privileges
            const defaultCoachData = {
              coachUserID: currentUser.uid,
              coachSubmitToOrgTime: new Date(),
              accessPrivilege: {
                groups: { view: true, write: true },
                events: { view: true, write: true },
                coaches: { view: true, write: true },
                students: { view: true, write: true },
                trainingPlan: { view: true, write: true },
              },
              coachStatus: "active",
            };

            const processedUserData = {
              ...rawUserData,
              coachData: coachDoc.exists ? coachDoc.data() : defaultCoachData,
            };

            setUserData(processedUserData);
          } else {
            setUserData(rawUserData);
          }
        } else {
          console.warn(
            "User document not found for real-time listening:",
            currentUser.uid
          );
        }
      },
      (error) => console.error("Error in real-time user data listener:", error)
    );

    let ownerUnsubscribe = null;
    if (ownerID && ownerID !== currentUser.uid) {
      ownerUnsubscribe = onSnapshot(
        doc(db, "users", ownerID),
        (ownerDocSnapshot) => {
          if (ownerDocSnapshot.exists()) {
            const ownerData = ownerDocSnapshot.data();
            if (userData?.userType === "coach") {
              setUserData((prevUserData) => ({
                ...prevUserData,
                paymentDetails: ownerData.paymentDetails,
                managerData: ownerData,
              }));
            }
          }
        },
        (error) =>
          console.error("Error in real-time owner data listener:", error)
      );
    }

    return () => {
      userUnsubscribe();
      if (ownerUnsubscribe) ownerUnsubscribe();
    };
  }, [currentUser?.uid, ownerID, userData?.userType]);

  // Real-time students listener
  useEffect(() => {
    if (!ownerID) return;

    const studentsUnsubscribe = onSnapshot(
      collection(db, "users", ownerID, "students"),
      (querySnapshot) => {
        const studentsData = [];
        querySnapshot.forEach((doc) => {
          studentsData.push({ id: doc.id, ...doc.data() });
        });
        setStudents(studentsData);
      },
      (error) => console.error("Error in real-time students listener:", error)
    );

    return () => {
      studentsUnsubscribe();
    };
  }, [ownerID]);

  // Real-time coaches listener
  useEffect(() => {
    if (!ownerID) return;

    const coachesUnsubscribe = onSnapshot(
      collection(db, "users", ownerID, "coaches"),
      async (querySnapshot) => {
        const coachesData = [];

        // Process each coach document
        for (const coachDoc of querySnapshot.docs) {
          const coachData = {
            id: coachDoc.id,
            ...coachDoc.data(),
          };

          // Fetch the coach's user data
          try {
            const userDocRef = doc(db, "users", coachData.coachUserID);
            const userDoc = await getDoc(userDocRef);

            if (userDoc.exists()) {
              coachesData.push({
                ...coachData,
                userData: userDoc.data(),
              });
            } else {
              // If user document doesn't exist, add coach data without userData
              coachesData.push(coachData);
            }
          } catch (error) {
            console.error("Error fetching coach user data:", error);
            // Add coach data without userData if there's an error
            coachesData.push(coachData);
          }
        }

        setCoaches(coachesData);
      },
      (error) => console.error("Error in real-time coaches listener:", error)
    );

    return () => {
      coachesUnsubscribe();
    };
  }, [ownerID]);

  // Real-time groups listener
  useEffect(() => {
    if (!ownerID) return;

    const groupsUnsubscribe = onSnapshot(
      collection(db, "users", ownerID, "groups"),
      (querySnapshot) => {
        const groupsData = [];
        querySnapshot.forEach((doc) => {
          groupsData.push({ id: doc.id, ...doc.data() });
        });
        setGroups(groupsData);
      },
      (error) => console.error("Error in real-time groups listener:", error)
    );

    return () => {
      groupsUnsubscribe();
    };
  }, [ownerID]);

  // Real-time events listener
  useEffect(() => {
    if (!ownerID) return;

    const eventsUnsubscribe = onSnapshot(
      collection(db, "users", ownerID, "events"),
      (querySnapshot) => {
        const eventsData = [];
        querySnapshot.forEach((doc) => {
          eventsData.push({ id: doc.id, ...doc.data() });
        });
        setEvents(eventsData);
      },
      (error) => console.error("Error in real-time events listener:", error)
    );

    return () => {
      eventsUnsubscribe();
    };
  }, [ownerID]);

  // Real-time professional content listener
  useEffect(() => {
    if (!ownerID) return;

    const professionalContentUnsubscribe = onSnapshot(
      collection(db, "users", ownerID, "professional_content"),
      (querySnapshot) => {
        if (!querySnapshot.empty) {
          // Get the first document (there should only be one)
          const firstDoc = querySnapshot.docs[0];
          setProfessionalContent(firstDoc.data());
        } else {
          // No professional content document exists yet
          setProfessionalContent(null);
        }
      },
      (error) => console.error("Error in real-time professional content listener:", error)
    );

    return () => {
      professionalContentUnsubscribe();
    };
  }, [ownerID]);

  // Joyride tour effect
  useEffect(() => {
    if (!isLoading && !localStorage.getItem("hasSeenNavTour")) {
      setRunNavTour(true);
    }
  }, [isLoading]);

  // Mobile detection effect
  useEffect(() => {
    const checkMobile = () => {
      if (isMobile()) {
        setShowMobileWarning(true);
      } else {
        setShowMobileWarning(false);
      }
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => {
      window.removeEventListener("resize", checkMobile);
    };
  }, []);

  // Joyride configuration
  const navTourSteps = [
    {
      target: ".dashboard-nav-pane",
      content:
        "ברוכים הבאים לאפליקציית SimplyCoach! בואו נעשה סיור קצר על המסכים השונים במערכת.",
      placement: "center",
      disableBeacon: true,
    },
    {
      target: '[data-tour="nav-home"]',
      content:
        "מסך הבית - כאן תוכלו לצפות בסיכום הנתונים השונים של הארגון, גרפים, סטטיסטיקה ארגונית, כמות ספורטאים בארגון ועוד!",
      placement: "left",
    },
    {
      target: '[data-tour="nav-community"]',
      content:
        "מסך הקהילה - כאן תוכלו לנהל את התקשורת מול הספורטאים והוריהם דרך פורטל הספורטאים, ותעקבו אחר התוכן המוצג בו לכלל הספורטאים בארגון!",
      placement: "left",
    },
    {
      target: '[data-tour="nav-events"]',
      content: "מסך האירועים - כאן תוכלו להקים ולנהל אירועים בארגון!",
      placement: "left",
    },
    {
      target: '[data-tour="nav-groups"]',
      content:
        "מסך הקבוצות - כאן תוכלו לפתוח ולנהל את קבוצות האימון בארגון, לקבוע ולשנות שעות אימון ועוד!",
      placement: "left",
    },
    {
      target: '[data-tour="nav-coaches"]',
      content:
        "מסך המאמנים - כאן תוכלו להוסיף מאמנים למערכת כך שיוכלו לעבוד איתכם בארגון בצורה קלה, ולנהל אותם באופן דיגיטלי!",
      placement: "left",
    },
    {
      target: '[data-tour="nav-students"]',
      content:
        "מסך הספורטאים - כאן תוכלו לצפות בכלל הספורטאים בארגון, לבצע סינוני מידע, לערוך נתוני ספורטאים ולהפיק דוחות",
      placement: "left",
    },
    {
      target: '[data-tour="nav-reports"]',
      content:
        "מסך דוחות מידע - כאן תוכלו להפיק דוחות מידע שונים בקלות לצורך הפקת מסקנות על הארגון והספורטאים שלכם!",
      placement: "left",
    },
    {
      target: '[data-tour="nav-training-plan"]',
      content:
        "מסך תוכנית האימונים - כאן תוכלו לכתוב ולערוך את תוכנית האימון של הארגון!",
      placement: "left",
    },
    {
      target: '[data-tour="nav-suppliers"]',
      content:
        "מסך הספקים - כאן תוכלו למצוא ספקי מוצרים ושירותים שונים מעולם הספורט שתוכלו לפנות אליהם במהירות!",
      placement: "left",
    },
    {
      target: '[data-tour="nav-settings"]',
      content:
        "מסך ההגדרות - כאן תוכלו לצפות ולעדכן את פרטי הארגון, לאפס סיסמא, לצפות בנתוני תוכנית השימוש שלכם ועוד!",
      placement: "left",
    },
    {
      target: '[data-tour="nav-logout"]',
      content: "לחצו כאן בכדי להתנתק מהמערכת",
      placement: "left",
    },
    {
      target: '[title="הפעל סיור מודרך"]',
      content:
        "התבלבלתם? בכל מסך יש כפתור עזרה שלחיצה עליו תוביל להסבר מהיר על המסך ואיך משתמשים בו!",
      placement: "left",
      spotlightClicks: true,
    },
    {
      target: '[data-tour="nav-help"]',
      content: "אם תרצו לראות את הסיור שוב, לחצו כאן בכל עת!",
      placement: "left",
      spotlightClicks: true,
    },
  ];

  const handleNavTourCallback = (data) => {
    const { status } = data;
    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      setRunNavTour(false);
      localStorage.setItem("hasSeenNavTour", "true");
    }
  };

  // Loading state
  if (isLoading || paymentCheckLoading || remoteConfigLoading) {
    return (
      <div className="loading-container">
        <div className="custom-spinner">
          <div className="spinner-circle"></div>
          <div className="spinner-circle"></div>
          <div className="spinner-circle"></div>
        </div>
      </div>
    );
  }

  // Coach blocked state
  if (shouldShowCoachBlocked()) {
    return (
      <CoachAccountBlocked
        reason={
          userData.userStatus === "waitingForOrgAccept"
            ? "pending_approval"
            : userData.userStatus === "disabled"
              ? "disabled"
              : isSuspended && suspensionReason === "grace_period_expired"
                ? "suspended"
                : needsPayment
                  ? "trial_ended"
                  : "payment"
        }
      />
    );
  }

  // Payment processing state
  if (!shouldShowDashboard()) {
    return (
      <>
        <div className="loading-container">
          <div className="custom-spinner">
            <div className="spinner-circle"></div>
            <div className="spinner-circle"></div>
            <div className="spinner-circle"></div>
          </div>
          <h2 className="mt-3" dir="rtl">
            ...
          </h2>
        </div>

        {/* Payment Modal - render even when dashboard is blocked */}
        {paymentsWebActive && currentScenario !== "H" && (
          <InAppPaymentModal
            isOpen={showPaymentModal}
            userData={userData}
            onPaymentComplete={handlePaymentComplete}
            onClose={() => {
              setShowPaymentModal(false);
              if (currentScenario === "A2" || currentScenario === "D1") {
                setHasClosedDismissibleModal(true);
              }
            }}
            isSuspended={isSuspended}
            suspensionReason={suspensionReason}
            currentScenario={currentScenario}
            trialDaysRemaining={trialDaysRemaining}
            billingFailureDaysRemaining={billingFailureDaysRemaining}
          />
        )}
      </>
    );
  }

  // Main dashboard
  return (
    <div className="page-container">
      <Joyride
        steps={navTourSteps}
        run={runNavTour}
        continuous
        showProgress
        showSkipButton
        scrollToFirstStep={true}
        scrollOffset={100}
        disableScrolling={false}
        callback={handleNavTourCallback}
        styles={{
          options: {
            arrowColor: "#fff",
            backgroundColor: "#fff",
            overlayColor: "rgba(0, 0, 0, 0.5)",
            primaryColor: "#0066CC",
            textColor: "#333",
            zIndex: 2000,
          },
          tooltipContainer: {
            direction: "rtl",
            textAlign: "right",
          },
          buttonNext: {
            backgroundColor: "#0066CC",
            fontSize: 14,
            padding: "8px 16px",
          },
          buttonBack: {
            marginRight: 10,
            fontSize: 14,
            padding: "8px 16px",
          },
          buttonSkip: {
            color: "#666",
            fontSize: 14,
            padding: "8px 16px",
          },
        }}
        locale={{
          back: "הקודם",
          close: "סגור",
          last: "סיום",
          next: "הבא",
          skip: "דלג",
        }}
      />

      <Container className="dashboard-container">
        <button
          className="tour-help-button"
          style={{
            position: "fixed",
            top: 30,
            right: 30,
            backgroundColor: "#0066CC",
            color: "white",
            border: "none",
            borderRadius: "50%",
            width: 48,
            height: 48,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            zIndex: 2000,
            boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
          }}
          onClick={() => setRunNavTour(true)}
          title="הפעל סיור מודרך על תפריט הניווט"
          data-tour="nav-help"
        >
          <FaQuestionCircle size={24} />
        </button>

        {userData && (
          <Tab.Container
            defaultActiveKey="groups"
            activeKey={currentTab}
            className="tabContainer"
          >
            <DashboardTabContent
              currentTab={currentTab}
              userData={userData}
              groups={groups}
              students={students}
              setEvaluationTemplates={setEvaluationTemplates}
              events={events}
              presenceLogs={presenceLogs}
              coaches={coaches}
              professionalContent={professionalContent}
              statsReports={statsReports}
              evaluationTemplates={evaluationTemplates}
              evaluationReports={evaluationReports}
              ownerID={ownerID}
              currentUser={currentUser}
              activateAlert={activateAlert}
              setCurrentTab={setCurrentTab}
              onEventUpdate={handleEventUpdate}
              onEventAdd={handleEventAdd}
              onEventDelete={handleEventDelete}
              onGroupUpdate={handleGroupUpdate}
              onGroupAdd={handleGroupAdd}
              onGroupDelete={handleGroupDelete}
              onStudentUpdate={handleStudentUpdate}
              onStudentAdd={handleStudentAdd}
              onStudentDelete={handleStudentDelete}
              isNavTourRunning={runNavTour}
            />

            <DashboardNavigation
              currentTab={currentTab}
              onTabSelect={setCurrentTab}
              onLogout={() => setShowLogoutModal(true)}
            />
          </Tab.Container>
        )}
      </Container>

      {/* Modals and Alerts */}
      {alert && (
        <CustomAlert
          type={alert.type}
          title={alert.title}
          message={alert.message}
        />
      )}

      <MobileWarningModal
        show={showMobileWarning}
        onDismiss={handleMobileWarningDismiss}
      />

      <LogoutModal
        show={showLogoutModal}
        onHide={() => setShowLogoutModal(false)}
        onConfirm={handleLogout}
        setCurrentTab={setCurrentTab}
      />

      {paymentsWebActive && currentScenario !== "H" && (
        <InAppPaymentModal
          isOpen={showPaymentModal}
          userData={userData}
          onPaymentComplete={handlePaymentComplete}
          onClose={() => {
            setShowPaymentModal(false);
            if (currentScenario === "A2" || currentScenario === "D1") {
              setHasClosedDismissibleModal(true);
            }
          }}
          isSuspended={isSuspended}
          suspensionReason={suspensionReason}
          currentScenario={currentScenario}
          trialDaysRemaining={trialDaysRemaining}
          billingFailureDaysRemaining={billingFailureDaysRemaining}
        />
      )}
    </div>
  );
};

export default Dashboard;
